import ApiClient from '@package/services/src/ApiClient'
import { EmptyResult } from '@package/services/src/Result'

import { WireTransferPaymentService } from "./services"

export default class WireTransferPaymentApiService
  implements WireTransferPaymentService {
  public constructor(private apiClient: ApiClient) { }

  public async checkout(): Promise<EmptyResult> {
    await this.apiClient.put('/shoppingCart/paymentMethod/wireTransfer')

    return new EmptyResult()
  }
}
